/* global firebase */
import Notifcations from '../notifications'

class FCM {
  init (config) {
    let self = this
    firebase.initializeApp(config)
  }

  start (VueApp) {
    let self = this
    let messaging = firebase.messaging()
    messaging.requestPermission()
    .then(function() {
      console.log('Notification permission granted.')
      VueApp.$store.commit('notificationPermission/hide')
      self.getToken(VueApp)
    })
    .catch(function(err) {
      console.log('Unable to get permission to notify.', err)
      VueApp.$store.commit('notificationPermission/show')
    })
  }

  getToken (VueApp) {
    let self = this
    let messaging = firebase.messaging()

    let onError = (err) => {
      console.log('An error occurred while retrieving token. ', err)
    }

    let getToken = (currentToken) => {
      if (currentToken) {
        console.log('FCM Token: ' + currentToken)
        VueApp.$store.commit('session/setNotificationToken', currentToken)
        VueApp.$sdk.post('/admin/notification/token', {
          token: VueApp.$store.state.session.sessionToken,
          notificationToken: currentToken
        }, r => {
          if (r.error) {
            console.log(r)
          }
        })
        return
      }
      // Show permission request.
      console.log('No Instance ID token available. Request permission to generate one.')
    }

    // Get initial token
    messaging.getToken()
      .then(getToken)
      .catch(onError)

    // Monitor token refresh
    messaging.onTokenRefresh(() => {
      console.log('FCM Token Refresh')
      messaging.getToken()
        .then(getToken)
        .catch(onError)
    })

    // start listening to notifications
    messaging.onMessage((payload) => {
      Notifcations.process(VueApp, payload)
    })
  }

  deleteToken (VueApp) {
    let notificationToken = VueApp.$store.state.session.notificationToken
    if (notificationToken !== null) {
      let messaging = firebase.messaging()
      messaging.deleteToken(notificationToken)
    }
  }
}

export default FCM



// WEBPACK FOOTER //
// ./src/modules/plugins/fcm.js